function formatarDataHora(dataHoraStr) {
    // Criando um objeto Date a partir da string
    let data = new Date(dataHoraStr);

    // Obtendo dia, mês e ano
    let dia = data.getDate().toString().padStart(2, '0');
    let mes = (data.getMonth() + 1).toString().padStart(2, '0'); // Mês começa em 0
    let ano = data.getFullYear();

    // Obtendo horas e minutos
    let horas = data.getHours().toString().padStart(2, '0');
    let minutos = data.getMinutes().toString().padStart(2, '0');

    // Retornando no formato desejado
    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}

export default formatarDataHora;